import axios from "axios";
import * as actionType from "../../../constant/actionType";

// Admin-side fetch assigned checklists for a worker by client
// Requires: client_org_id, worker_id
export const AdminGetAllAssignedChecklistOfWorker = (ApiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: ApiData?.client_org_id, // ensure client org header
      },
      url: `${actionType.environment_url}/api/admin/provider/GetAllAssignedChecklistOfWorker`,
      params: ApiData,
    });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error?.message || "Unknown error" };
  }
};

// Admin-side update worker checklist assignments
// Expects payload including client_org_id, provider_org_id, worker_id, assignChecklistIds, removeChecklistIds
export const AdminUpdateWorkerChecklistAssign = (ApiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "put",
      data: ApiData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: ApiData?.client_org_id,
      },
      url: `${actionType.environment_url}/api/admin/provider/UpdateWorkerChecklistAssign`,
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error?.message || "Unknown error" };
  }
};
